module.exports = __webpack_public_path__ + "static/media/laddu_peda_hugging.214d060d.gif";